const emailkeys={
    service_id:'service_73xwl28',
    templateMp_id:'template_xhetagd',
    public_key:'7ACUp7dazshP2XOlW'
}

export default emailkeys